import React from 'react'
import PropTypes from 'prop-types'
import { Tile, BodyText } from '@paypalcorp/pp-react'
import cssModules from 'react-css-modules'
import styles from './charity_tile.less'

class CharityTile extends React.Component {
  static propTypes = {
    charity: PropTypes.object,
    logo_url: PropTypes.string,
    name: PropTypes.string,
    slogan: PropTypes.string,
    key: PropTypes.number,
    selectCharity: PropTypes.func,
  }
  render() {
    const { charity, logo_url, name, key, selectCharity } = this.props
    return (
      <Tile
        card
        key={key}
        styleName="tile-wrap"
        onClick={e => selectCharity(charity)}
        onKeyPress={e => {
          if (e.key === 'Enter') {
            selectCharity(charity)
          }
        }}
        tabindex="0"
      >
        <Tile.Content styleName="tile-content" data-nemo="charity-tile">
          <div
            styleName="charity-tile-logo"
            style={{
              background: `url(${logo_url}) center center / contain no-repeat, center center`,
            }}
          />
          <div>
            <BodyText styleName="charity-title">{name}</BodyText>
          </div>
        </Tile.Content>
      </Tile>
    )
  }
}
export default cssModules(CharityTile, styles)
